import Header from './components/Header';
import Hero from './components/Hero';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FaqSection />
        <CarouselSection />
        <CommentsSection />
        <UpdatesSection />
        <RankingSection />
        <IndexSection />
        <CardsSection />
        <MediaSection />
        <FeaturesSection />
        <ContactSection />
        <TopicsSection />
        <AboutSection />
        <AppSection />
      </main>
      <Footer />
    </>
  );
}